import React from 'react';
import { createSvgIcon } from '../../utils/createSvgIcon';

export const ActionAddShrap = createSvgIcon(
  <svg
    width="249"
    height="249"
    viewBox="41 49 151 151"
    fill="none"
    fillRule="evenodd"
    clipRule="evenodd"
  >
    <g fill="currentColor">
      <path d="M122.482 57.1575L182.9 92.0399V151.826H172.98V97.7672L122.482 68.6121L73.3102 97.0014L52.3887 86.1198L56.9661 77.319L73.0614 85.6904L122.482 57.1575ZM71.9838 156.078V105.577H62.0638V161.805L122.482 196.687L171.903 168.154L187.998 176.526L192.575 167.725L171.654 156.843L122.482 185.233L71.9838 156.078Z" />
      <path d="M126.383 104.859V152.214H116.463V104.859H126.383Z" />
      <path d="M145.098 133.495L97.7421 133.495L97.7421 123.575L145.098 123.575L145.098 133.495Z" />
    </g>
  </svg>,
  'ActionAddShrap'
);
